import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { menuGroups } from "@/lib/menu";

// Slugs que servem apenas como atalho para outra tela.
const SLUG_REDIRECTS: Record<string, string> = {};

export const Route = createFileRoute("/_authenticated/m/$slug")({
  beforeLoad: ({ params }) => {
    const target = SLUG_REDIRECTS[params.slug];
    if (target) throw redirect({ to: target });
  },
  component: PlaceholderPage,
});

function PlaceholderPage() {
  const { slug } = Route.useParams();
  const item = menuGroups.flatMap((g) => g.items).find((i) => i.slug === slug);
  const Icon = item?.icon;

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        {Icon && <Icon className="h-7 w-7 text-primary" />}
        <h1 className="text-3xl font-bold tracking-tight">
          {item?.title ?? "Página"}
        </h1>
      </div>
      <div className="rounded-lg border bg-card p-10 text-center">
        <p className="text-muted-foreground">
          Tela em construção. Vamos montar essa funcionalidade nos próximos passos.
        </p>
        <Link
          to="/dashboard"
          className="mt-4 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Voltar ao Menu Principal
        </Link>
      </div>
    </div>
  );
}
